/** @jsx jsx */

import { useState } from 'react';
import { jsx, css } from '@emotion/core';

import { Grid, Spacer, Text } from '@zapier/design-system';

import ManagerLayout from 'app/developer-v3/layouts/ManagerLayout';
import VersionDropdown from 'app/developer-v3/components/VersionDropdown';
import VersionHistory from 'app/developer-v3/components/VersionHistory';
import { ALL_VERSIONS_TEXT } from 'app/developer-v3/constants';
import {
  useActiveProfile,
  useQueryAuditLogs,
  useRouter,
} from 'app/developer-v3/hooks';

import { AUDIT_LOGS_LIMIT } from './constants';
import { filterAuditLogs } from './utils';

import type { SemVer } from 'app/developer-v3/types/version';

const Styles = {
  logsSection: css`
    overflow-wrap: anywhere;
  `,
};

type Props = {
  versions: Array<SemVer>;
};

function HistoryPage({ versions }: Props) {
  const [version, setVersion] = useState<string>(undefined);

  const { params } = useRouter();
  const { id: integrationId } = params;

  const { data: auditLogs, isLoading: isLoadingAuditLogs } = useQueryAuditLogs({
    integrationId,
    version,
  });

  const {
    activeProfile,
    isLoading: isLoadingActiveProfile,
  } = useActiveProfile();
  const isStaff = activeProfile?.isStaff ?? false;

  const updatedAuditLogs = filterAuditLogs(auditLogs);

  return (
    <ManagerLayout title="History">
      <div css={Styles.logsSection}>
        <Grid alignItems="center" columns="1fr auto">
          <Text fontWeight={600} tag="h2" type="ParagraphHeader3">
            Audit Logs
          </Text>
          <VersionDropdown
            chosenLabel="Viewing"
            onChange={versionNext =>
              setVersion(
                versionNext === ALL_VERSIONS_TEXT ? undefined : versionNext
              )
            }
            version={version || ALL_VERSIONS_TEXT.toLowerCase()}
            versions={[ALL_VERSIONS_TEXT, ...versions]}
          />
        </Grid>
        <Spacer height={10} />
        <VersionHistory
          isLoading={isLoadingActiveProfile || isLoadingAuditLogs}
          isStaff={isStaff}
          isTitleVisible={false}
          isVersionColumnVisible={true}
          logs={updatedAuditLogs}
        />
        <Text margin="20px 0px" tag="p">
          This will show at most the latest {AUDIT_LOGS_LIMIT} audit logs.
        </Text>
      </div>
    </ManagerLayout>
  );
}

export default HistoryPage;
